import React from "react";
import * as styles from "../block/block.module.scss";

/**
 * @type {Object} 「UI:atoms - ブロック Call To Action コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {String} title タイトルを受け取るための引数です。
 * @param {Object} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 * @param {String} url CVボタンに設定したURLを受け取るための引数です。
 * @param {String} label CVボタンに設定したラベルを受け取るための引数です。
 *
 */

const Cta = ({ title, children, url, label }) => {
  return (
    <section className={`${styles.cta}`}>
      {title !== null && (
        <header>
          <h2>{title}</h2>
        </header>
      )}
      <div>{children}</div>

      <footer>
        {(label !== null && url !== null) && (
          <span className={`${styles.linkButton}`}>
            {url.substring(0, 1) === "/" ? (
              <a href={url}>{label}</a>
            ) : (
              <a href={url} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            )}
          </span>
        )}
      </footer>
    </section>
  );
};

export default Cta;
